import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { Box, Flex, Text } from '@theme-ui/components';
import { Icon } from '../atoms';
import { InfoTile, Pagination } from '../molecules';
import { typography, colors } from '../../styles/theme';

const labelStyle = { ...typography.textSm, color: colors.black };

const TopLabel = ({ publishDate, author }) => {
	return (
		<Text sx={labelStyle}>
			{publishDate} {author && <Text>| {author}</Text>}
		</Text>
	);
};

const BottomLabel = ({ topic }) => (
	<Box>
		<Icon
			name='Tag'
			color={colors.black}
			size={16}
		/>
		<Text sx={{ pl: '0.5rem', ...labelStyle }}>{topic?.name}</Text>
	</Box>
);

const ResourceList = ({
	resources,
	pageContext,
	justifyContent = 'center',
	customStyles,
}) => {
	const regionPath = pageContext.regionPath ? `/${pageContext.regionPath}` : '';
	const { slug, numPages, currentPage } = pageContext;
	return (
		<Flex sx={{ ...styledWrapper, ...customStyles }}>
			<Flex
				sx={{
					pb: ['3rem', '3rem', '3rem', '4rem'],
					flexWrap: 'wrap',
					gap: '1.5rem',
					justifyContent,
				}}
			>
				{resources.nodes.map((resource, i) => {
					const regionUrl = `${regionPath}${resource?.url}`;
					return (
						<InfoTile
							image={resource?.cardImage}
							imageAltText={resource?.cardImage?.alt}
							title={resource?.title}
							content={resource?.description}
							topLabel={
								(resource?.publishDate || resource?.author?.firstName) && (
									<TopLabel
										publishDate={resource?.publishDate}
										author={resource?.author?.firstName}
									/>
								)
							}
							bottomLabel={
								resource?.topic && <BottomLabel topic={resource?.topic} />
							}
							hasBorder={false}
							url={regionUrl}
						/>
					);
				})}
			</Flex>
			<Pagination
				currentPage={currentPage}
				totalItems={numPages*6}
				itemsPerPage={6}
				onPageChange={(activePage) =>
					activePage === 1
						? navigate(`${slug}/`)
						: navigate(`${slug}/${activePage}/`)
				}
				customStyles={{ maxWidth: ['18.75rem', '20rem', '43rem'] }}
			/>
		</Flex>
	);
};

const styledWrapper = {
	justifyContent: 'center',
	flexDirection: 'column',
	width: '100%',
	mx: 'auto',
};

ResourceList.propTypes = {
	resources: PropTypes.object,
	pageContext: PropTypes.object,
	justifyContent: PropTypes.string,
};

TopLabel.propTypes = {
	publishDate: PropTypes.string,
	author: PropTypes.string,
};

BottomLabel.propTypes = {
	topic: PropTypes.object,
};

export default ResourceList;
